/**
 * Capitalizes first word of string
 * @param {string} s
 */
export const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);

/**
 * Truncate string at given length 
 * @param {string} s 
 * @param {number} maxLength 
 */
export const truncateString = (s, maxLength = 50) => {
	if (!s) return null;
	if (s.length <= maxLength) return s;
	return `${s.substring(0, maxLength)}...`;
};